<style lang="scss" scoped>
.speaker-card {
    display: block;
    position: relative;

    .image-wrapper {
        overflow: hidden;
        border-radius: 4px;
        position: relative;

        img {
            position: absolute;
            top: 0px;
            bottom: 0px;
            left: 0px;
            right: 0px;
            width: 100%;
            height: 100%;

            object-fit: cover;
            font-family: "object-fit: cover;";
            transition: transform 0.15s;
        }
    }

    .xsmall {
        line-height: 1.2;
    }

    &:hover {
        img {
            transform: scale(1.1);
        }
    }
}
</style>

<template>
    <a v-if="speaker" class="speaker-card w-100 h-100 text-decoration-none text-dark" :href="route('nl.speaker', {'slug': speaker.slug})">
        <div class="image-wrapper" :style="{ 'padding-top' : ratio ? `${ arHeight / arWidth * 100 }%` : '240px' }">
            <img v-if="speaker.acf && speaker.acf.image" :src="speaker.acf.image.sizes.large" :alt="speaker.title.rendered" class="w-100">
        </div>

        <p class="mb-0 mt-8 small" v-html="speaker.title.rendered"></p>
        <template v-if="speaker.acf && speaker.acf.bullet_points">
            <p class="xsmall" v-for="(bulletPoint, index) in speaker.acf.bullet_points" :key="index">{{ bulletPoint.bullet_point }}</p>
        </template>
    </a>
</template>

<script>
export default {
    name: "elements.speaker-card",

    props: {
        speaker: {
            type: Object,
            required: false,
        },
        ratio: {
            type: [String, Boolean],
            required: false
        }
    },


    computed: {
        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },
        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        }
    }
}
</script>